const getInputValue = valueOrEvent => {
  if (valueOrEvent && typeof valueOrEvent === 'object') {
    if ('target' in valueOrEvent || 'currentTarget' in valueOrEvent) {
      return valueOrEvent.target?.value ?? valueOrEvent.currentTarget?.value ?? '';
    }
  }

  return valueOrEvent ?? '';
};

export {getInputValue};
